import { useState } from "react";
import { motion } from "framer-motion";
import { AREAS } from "@/lib/data";

// Stylized Iowa silhouette (simplified path) with highlighted towns in the SW corner.
export const IowaMap = () => {
  const [active, setActive] = useState(AREAS[0].name);

  return (
    <div className="relative rounded-2xl bg-crate-surface border border-white/10 p-6 md:p-8 overflow-hidden" data-testid="iowa-map">
      <svg viewBox="0 0 100 78" className="w-full h-auto">
        {/* Iowa outline (stylized) */}
        <motion.path
          d="M6,14 L20,12 L34,10 L52,9 L72,9 L90,10 L94,14 L94,20 L92,26 L90,34 L92,42 L90,50 L86,58 L80,64 L70,68 L58,70 L46,71 L34,70 L24,66 L16,60 L10,52 L7,42 L5,30 Z"
          fill="rgba(244,197,66,0.06)"
          stroke="#F4C542"
          strokeWidth="0.6"
          initial={{ pathLength: 0 }}
          whileInView={{ pathLength: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.6, ease: "easeInOut" }}
        />
        {AREAS.map((a, i) => (
          <g key={a.name} onMouseEnter={() => setActive(a.name)} className="cursor-pointer">
            <motion.circle
              cx={a.x} cy={a.y} r={active === a.name ? 2.6 : 1.8}
              fill="#F4C542"
              initial={{ scale: 0, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.8 + i * 0.12, type: "spring", stiffness: 260 }}
            />
            {active === a.name && (
              <circle cx={a.x} cy={a.y} r="4.5" fill="none" stroke="#F4C542" strokeWidth="0.4" opacity="0.5">
                <animate attributeName="r" from="2.6" to="6" dur="1.4s" repeatCount="indefinite" />
                <animate attributeName="opacity" from="0.6" to="0" dur="1.4s" repeatCount="indefinite" />
              </circle>
            )}
            <text x={a.x + 3.5} y={a.y + 1} fontSize="3" fill={active === a.name ? "#F4C542" : "rgba(255,255,255,0.55)"} className="font-body font-semibold select-none">
              {a.name}
            </text>
          </g>
        ))}
      </svg>

      <div className="mt-6 flex flex-wrap gap-2" data-testid="area-chips">
        {AREAS.map((a) => (
          <button
            key={a.name}
            onMouseEnter={() => setActive(a.name)}
            data-testid={`area-chip-${a.name.toLowerCase()}`}
            className={`rounded-full px-4 py-1.5 text-sm font-semibold border transition-colors ${active === a.name ? "bg-crate-yellow text-crate-black border-crate-yellow" : "border-white/15 text-white/70 hover:border-crate-yellow"}`}
          >
            {a.name}
          </button>
        ))}
        <span className="rounded-full px-4 py-1.5 text-sm font-semibold border border-dashed border-white/20 text-white/40">
          More coming soon
        </span>
      </div>
    </div>
  );
};
